import { VStack, ScrollView } from "@gluestack-ui/themed";
import { SideBarProps } from "./types";
import { SideBarItem } from "./components/SidebarItem";
import { useEffect, useRef, useState } from "react";
import { SideMenu } from "../SideMenu";
import { IMenuItem } from "../types";
import { Drawer } from "../Drawer";
import { IModalRefProps } from "../Drawer/types";
import { CanView } from "@repo/core/components/core/CanView";
import { Text } from "@repo/core/components/core/Text";
import { useAppVersion } from "@repo/core/hooks/useAppVersion";
export const SideBar = ({ items, onItemPress }: SideBarProps) => {
  const appVersion = useAppVersion();
  const [selected, setSelected] = useState<IMenuItem | null>();
  const subMenuDrawerRef = useRef<IModalRefProps>();

  useEffect(() => {
    if (typeof window !== "undefined" && window.location.pathname) {
      const path = window.location.pathname.replace("/", "");
      const item = items.find((item) => item.key === path);
      setSelected(item || items[0]);
    }
  }, [items]);

  const handlerItemPress = (item: IMenuItem) => {
    setSelected(item);
    onItemPress?.(item);
    if (item?.items?.length) {
      subMenuDrawerRef.current?.open();
      return;
    }
    subMenuDrawerRef.current?.close();
  };

  return (
    <VStack height={"$full"} position="relative">
      <VStack
        bg={"white"}
        borderRightWidth={1}
        borderColor="$borderLight200"
        zIndex={2}
        width={"$100vw"}
        maxWidth={240}
        flex={1}
      >
        {/* MAIN */}
        <VStack flex={1} py={"$10"} px={"$5"}>
          <ScrollView contentContainerStyle={{ flexGrow: 0.9 }}>
            <VStack flex={1} gap="$4">
              {items?.map((item) => (
                <CanView permissions={item?.permissions} key={item.key}>
                  <SideBarItem
                    icon={item.icon}
                    label={item.label}
                    isSelected={selected?.key === item.key}
                    onPress={() => handlerItemPress(item)}
                  />
                </CanView>
              ))}
              <VStack flex={1} alignItems="center" justifyContent="flex-end">
                <Text fontSize="$sm" color="$secondary400">
                  v{appVersion}
                </Text>
              </VStack>
            </VStack>
          </ScrollView>
        </VStack>
      </VStack>

      <Drawer width="$32" ref={subMenuDrawerRef} xOffset="$32">
        <SideMenu
          showHeader={false}
          items={selected?.items || []}
          onItemPress={onItemPress}
        />
      </Drawer>
    </VStack>
  );
};
